import * as api from "app/api/templates"
import { SagaIterator } from "redux-saga"
import { call, put, takeLatest } from "redux-saga/effects"
import * as actions from "./templateAvailabilities.actions"
import { handleError } from "../errorHandler/errorHandler.saga"

export function* getAvailabilitiesFlow(action: actions.GetAvailabilities): SagaIterator {
  try {
    const { templateId, params } = action.payload
    const response = yield call(api.getAvailabilities, templateId, params)
    yield put(actions.getAvailabilitiesSuccess(response?.data))
  } catch (e) {
    yield put(actions.getAvailabilitiesFail(e))
    yield call(handleError, { error: e })
  }
}

export default function* templateAvailabilitiesSaga(): SagaIterator {
  yield takeLatest(actions.Types.GET, getAvailabilitiesFlow)
}
